import React, { ReactElement } from 'react';
import LoadingSpinner from 'components/elements/loadingSpinner';
import Loader from './Loader';

export interface BoundaryProps {
  loading: boolean;
  children: ReactElement;
}
const Boundary = ({ loading, children }: BoundaryProps) => {
  if (loading) return <LoadingSpinner loading={loading} />;
  return children;
};

export default Boundary;
